module.exports = __webpack_public_path__ + "static/media/ic-open-in-new-white.96785780.svg";